import React from 'react';
import { useInView } from 'react-intersection-observer';

interface LazyLoadListScrollTriggerProps {
  rootRef?: HTMLElement | null;
  renderMore?: () => void;
}

export const LazyLoadListScrollTrigger: React.FunctionComponent<LazyLoadListScrollTriggerProps> = ({
  rootRef,
  renderMore,
}) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: '0px 0px 100px 0px',
    root: rootRef,
  });
  React.useEffect(() => {
    if (inView && renderMore) renderMore();
  }, [inView, renderMore]);

  return (
    <div
      data-component="LazyLoadListScrollTrigger"
      data-testid="lazy-load-list-scroll-trigger"
      ref={ref}
    />
  );
};
